import { render, staticRenderFns } from "./QcDownload.vue?vue&type=template&id=0f5a89f4&scoped=true"
import script from "./QcDownload.vue?vue&type=script&lang=js"
export * from "./QcDownload.vue?vue&type=script&lang=js"
import style0 from "./QcDownload.vue?vue&type=style&index=0&id=0f5a89f4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f5a89f4",
  null
  
)

export default component.exports